import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AboutComponent } from './about/about.component';
import { BecomeAPeerSupportComponent } from './become-a-peer-support/become-a-peer-support.component';
import { ChangeLanguageComponent } from './change-language/change-language.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { HelpUsComponent } from 'src/app/help-us/help-us.component';
import { HomeComponent } from './home/home.component';
import { MenuComponent } from './menu/menu.component';
import { PolicyHomeComponent } from './policy-home/policy-home.component';
import { PolicyTermsComponent } from './policy-terms/policy-terms.component';
import { ResourcesComponent } from './resources/resources.component';
import { SafetyPlanComponent } from './safety-plan/safety-plan.component';
import { SelfCareComponent } from './self-care/self-care.component';
import { SetLanguageComponent } from './set-language/set-language.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'landing-page',
  },
  {
    path: 'landing-page',
    component: SetLanguageComponent
  },
  {
    path: 'home-chat',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    component: HomeComponent,
    path: 'home'
  },
  {
    component: SelfCareComponent,
    path: 'self-care'
  },
  {
    component: ResourcesComponent,
    path: 'resource'
  },
  {
    path: 'app',
    pathMatch: 'full',
    redirectTo: 'set-language'
  },
  {
    component: MenuComponent,
    path: 'menu'
  },
  {
    component: SafetyPlanComponent,
    path: 'safety-plan'
  },
  {
    component: AboutComponent,
    path: 'about'
  },
  {
    component: HelpUsComponent,
    path: 'help-us'
  },
  {
    component: PolicyHomeComponent,
    path: 'policy-disclaimer'
  },
  {
    component: PolicyTermsComponent,
    path: 'policy-terms'
  },
  {
    component: DisclaimerComponent,
    path: 'app-disclaimer'
  },
  {
    component: ChangeLanguageComponent,
    path: 'change-language'
  },
  {
    component: ContactUsComponent,
    path: 'contact-us'
  },
  {
    component: BecomeAPeerSupportComponent,
    path: 'become-a-peer-supporter'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
